import type { QueueDashboardSettings } from './types'

export const MAX_CONSECUTIVE_FAILURES = 3
export const BACKOFF_MULTIPLIER = 1.5
export const DEFAULT_RETRY_COUNTDOWN_SECONDS = 30

export const DEFAULT_SETTINGS: QueueDashboardSettings = {
  refreshInterval: 15000,
  holdAlertThreshold: 45,
  sampleHistoryMinutes: 720,
}

export const QUEUE_DASHBOARD_SETTINGS_KEY = 'com.mango.reports.queuedashboard'

export const REFRESH_INTERVAL_OPTIONS = [15, 25, 30, 45, 60] as const

export type RefreshIntervalOption = (typeof REFRESH_INTERVAL_OPTIONS)[number]

export const REFRESH_INTERVAL_OPTIONS_WITH_LABELS =
  REFRESH_INTERVAL_OPTIONS.map((seconds) => ({
    value: seconds * 1000,
    label: `${seconds} seconds`,
    seconds,
  }))

export const HOLD_ALERT_THRESHOLD_MIN = 5
export const HOLD_ALERT_THRESHOLD_MAX = 300
export const HOLD_ALERT_THRESHOLD_STEP = 5

export const HOLD_ALERT_THRESHOLD_OPTIONS: number[] = Array.from(
  {
    length:
      (HOLD_ALERT_THRESHOLD_MAX - HOLD_ALERT_THRESHOLD_MIN) /
        HOLD_ALERT_THRESHOLD_STEP +
      1,
  },
  (_, i) => HOLD_ALERT_THRESHOLD_MIN + i * HOLD_ALERT_THRESHOLD_STEP,
)

export const HOLD_ALERT_THRESHOLD_OPTIONS_WITH_LABELS =
  HOLD_ALERT_THRESHOLD_OPTIONS.map((seconds) => ({
    value: seconds,
    label: `${seconds} seconds`,
  }))

export const SAMPLE_HISTORY_OPTIONS = [30, 60, 120, 360, 720, 1440] as const

export type SampleHistoryOption = (typeof SAMPLE_HISTORY_OPTIONS)[number]

const SAMPLE_HISTORY_LABELS: Record<SampleHistoryOption, string> = {
  30: '30 min',
  60: '1 hr',
  120: '2 hr',
  360: '6 hr',
  720: '12 hr',
  1440: '24 hr',
}

export const SAMPLE_HISTORY_OPTIONS_WITH_LABELS = SAMPLE_HISTORY_OPTIONS.map(
  (minutes) => ({
    value: minutes,
    label: SAMPLE_HISTORY_LABELS[minutes],
    minutes,
  }),
)
